// @flow
import React, { Component, type ComponentType } from "react";

type Props = {|
    PhotoCard: ComponentType<any>,
    Dialog: ComponentType<any>,
    photo: ComponentType<any>,
    onHidePhoto: Function
|};

class PhotoDialog extends Component<Props> {
    handleClose = () => {
        this.props.onHidePhoto();
    };

    render() {
        const { photo, Dialog, PhotoCard } = this.props;
        return (
            <Dialog open={photo !== null} onHide={this.handleClose}>
                {photo !== null && <PhotoCard key={photo.id} photo={photo} />}
            </Dialog>
        );
    }
}

export default PhotoDialog;



// WEBPACK FOOTER //
// ./src/photo-dialog/view.js